import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

interface InputErrorProps {
  message?: string;
  className?: string;
}

const InputError: React.FC<InputErrorProps> = ({ message, className = '' }) => {
  if (!message) return null;

  return (
    <div className={`flex items-center gap-1 mt-1 ${className}`}>
      <ExclamationCircleIcon className="h-4 w-4 text-danger-500 min-w-[16px]" />
      <Text size="small" color="danger" weight="regular">
        {message}
      </Text>
    </div>
  );
};

export default InputError;
